"use strict";

(function ($, Drupal) {
  Drupal.getUrlParameter = function (name) {
    var str = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp("[\\?&]".concat(str, "=([^&#]*)"));
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };
})(jQuery, Drupal);